import { Injectable } from "@angular/core";
import { PmsClipbpardsDto } from "../interfaces/pms-clipboard.dto";
import { PmsClipbpards } from "../interfaces/pms-clipboards.interface";

@Injectable({
  providedIn: 'root'
})
export class PmsClipboardsAdapter {
  run(clipboards: PmsClipbpardsDto): PmsClipbpards {
    return {
      ...clipboards
    };
  }
}